import(/* webpackMode: "eager", webpackExports: ["PlatformCatalog"] */ "/vercel/path0/src/components/platformCatalog/platformCatalog.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformsHero"] */ "/vercel/path0/src/components/platformsHero/platformsHero.comp.tsx");
